import { Modal, Button } from 'react-bootstrap'

export const UpdateProfileModal = ({ show, setShowModal, handleUpdate }) => {

	return (
		<>
			<Modal 
				show={show} 
				onHide={() => { setShowModal(false) }}
			>
				<Modal.Header closeButton>
					<Modal.Title>Complete Your Profile First</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				To apply for this job, please complete your profile so that employers can better understand your skills and experiences.
				</Modal.Body>
				<Modal.Footer>
					<Button variant='primary' className='text-white' onClick={handleUpdate}>
						Update Now
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}
